document.addEventListener('input', function (e) {
  if (e.target.name !== 'country_code' && e.target.name !== 'language_code') return;
  
  const form = e.target.closest('localization-form')?.querySelector('form');
  if (!form) return;

  const countryCode = form.querySelector('input[name="country_code"]')?.value;
  const languageCode = form.querySelector('input[name="language_code"]')?.value;
  const returnTo = window.location.pathname;

  // Очищаем конфликтующие cookies
  document.cookie = 'localization=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
  document.cookie = 'localization=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/uk-ua/;';

  let body = `form_type=localization&utf8=✓&_method=put&return_to=${returnTo}`;
  if (countryCode) body += `&country_code=${countryCode}`;
  if (languageCode) body += `&language_code=${languageCode}`;

  fetch('/localization', {
    method: 'POST',
    headers: {'Content-Type': 'application/x-www-form-urlencoded'},
    body: body
  }).then(r => {
    window.location.href = r.url;
  });
});